import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=432d67f9&scoped=true&"
import script from "./richText.vue?vue&type=script&lang=js&"
export * from "./richText.vue?vue&type=script&lang=js&"
import style0 from "./richText.vue?vue&type=style&index=0&id=432d67f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d67f9",
  null
  
)

export default component.exports